import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './EventCustomer.module.css';
import { useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';
import { WelletContext } from '../../../context/WelletContext';
import { getLocale } from '../../../helpers/dates';
import { useHistory } from 'react-router-dom';
import EventCardChecker from '../../../components/EventsChecker/EventCardChecker';
import EmptyActivity from '../../../components/Common/EmptyActivity/EmptyActivity';
import AccountHeaderConsumer from '../../../components/HeaderConsumer/HeaderConsumer';
import { CircleSpinner } from 'react-spinners-kit';
import { getCookie } from '../../../helpers/cookie';
import FilterEvents from '../../../components/Venues/FilterEvents';
import { SkeletonFilters } from '../../../components/Skeletons/SkeletonVenueList';
import { useTranslation } from 'react-i18next';
import ChevronIcon from '../../../components/icons/chevronIcon';
import NavSelector from '../../../components/NavSelector/NavSelector';

const EventsCustomer = () => {
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation();
  const app = useSelector((state) => state.app);
  const locale = getLocale(app.language);
  const history = useHistory();
  const [eventBanners, setEventBanners] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [filters, setFilters] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState('ALL');
  const language = useSelector((state) => state.app.language);
  const cityCookie = getCookie('defaultCity');
  const selectedCity = cityCookie
    ? JSON.parse(cityCookie)
    : { id: null, name: t('allFem'), nameLong: '' };

  useEffect(() => {
    fetchEventBanners('ALL');
    getFilters();
  }, []);

  const getFilters = async () => {
    try {
      const result = await welletContext.apis.tickets.get('/shows/categories', {
        params: { cityId: selectedCity.id },
      });
      setFilters(result.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingFilters(false);
    }
  };
  const fetchEventBanners = async (filter = 'ALL') => {
    setLoadingEvents(true);
    let query = `/shows/upcoming/events?skip=0&take=10&lang=${language}`;

    if (filter === 'UPCOMING') {
      query += `&eventCustomerFilter=UPCOMING`;
    } else if (filter === 'TODAY') {
      query += `&eventCustomerFilter=TODAY`;
    } else if (filter === 'ALL') {
      query += `&eventCustomerFilter=ALL`;
    }

    if (selectedCity?.id) {
      query += `&cityId=${selectedCity.id}`;
    }

    try {
      const result = await welletContext.apis.tickets.get(query);
      if (result.data?.errorCode === 'EVENT_NOT_FOUND') {
        setEventBanners([]);
        return;
      }

      if (result.data.length === 0) {
        setEventBanners([]);
      } else {
        setEventBanners(result.data);
        setErrorMessage(null);
      }
    } catch (error) {
      console.error(error);

      setEventBanners([]);
    } finally {
      setLoadingEvents(false);
    }
  };

  const onFilterChange = (filter) => {
    const filterId = filter ? filter.id : 'ALL';
    setSelectedFilter(filterId);
    fetchEventBanners(filterId);
  };
  const reservationType = 'TICKETS';

  const handleFilterClick = (showId) => {
    history.push({
      pathname: reservationType === 'restaurant' ? '/reservation-restaurant' : '/event-selector',
      search: `?showId=${showId}`,
    });
  };

  return (
    <>
      <AccountHeaderConsumer
        title={
          <div
            className={`text-white font-medium ${styles.cityContainer}`}
            onClick={() => history.push(`/city-selector?events=/events`)}
          >
            {selectedCity?.name} <ChevronIcon size='15' color='#fff' rotation={90} />
          </div>
        }
      />

      <div className='env-bottom env-top'>
        {loadingFilters ? (
          <div className='ml-2 mt-4 mr-2'>
            <SkeletonFilters />
          </div>
        ) : (
          <div className={`${styles.highlight} ml-2 mt-4 fade-up`}>
            <div className='mt-3'>
              <FilterEvents
                onFilterChange={onFilterChange}
                selectedFilter={selectedFilter}
                show={selectedCity.id}
              />
            </div>
          </div>
        )}

        {loadingEvents ? (
          <div className='loaderDiv'>
            <CircleSpinner
              className='spinner-app mx-auto'
              style={{ margin: 'auto' }}
              size={40}
              color='var(--color-font-primary)'
            />
          </div>
        ) : eventBanners.length > 0 ? (
          eventBanners.map((show) => (
            <div
              key={show.showId}
              style={{ marginLeft: '15px', marginBottom: '15px', marginTop: '15px' }}
            >
              <div className={styles.containerTitle}>
                <div>{show.showName}</div>
                <div
                  onClick={() => handleFilterClick(show.showId)}
                  className='text-description mt-2'
                  style={{ fontWeight: '400' }}
                >
                  {t('viewAll')}
                </div>
              </div>

              <Swiper slidesPerView='auto' effect='slide' touchRatio={1.2}>
                {show.events.map((event) => (
                  <SwiperSlide key={event.id}>
                    <div
                      style={{
                        overflow: 'hidden',
                        marginRight: '10px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                      }}
                    >
                      <EventCardChecker
                        title={event.name}
                        locale={locale}
                        id={event.id}
                        startDate={event.startDate}
                        image={event.bannerImage}
                        onHandleClick={() => history.push(`/event?eventId=${event.id}`)}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ))
        ) : (
          <div className='mt-3 m-2'>
            <EmptyActivity title={t('weAreSorry')} subtitle={t('currentlyNoEventsInThisSection')} />
          </div>
        )}
      </div>

      <NavSelector history={history} />
    </>
  );
};

export default EventsCustomer;
